import accountSettingsModule from '../accountSettingsModule';

function accountStateProperties() {
  'ngInject';

  return {
    restrict: 'A',
    link(scope, element, attrs) {
      scope.accountData = !scope.accountData
        ? {
            stateProperties: {}
          }
        : scope.accountData;
      scope.accountData.stateProperties = {
        cancelRenewalUrl: attrs.cancelrenewalurl,
        upgradeMemberShipUrl: attrs.upgrademembershipurl,
        isRobloxCreditEnabled: attrs.isRobloxCreditEnabled,
        paymentHistoryUrl: attrs.paymenthistoryurl,
        isPaymentHistoryEnabled: attrs.isPaymentHistoryEnabled,
        hideMobileTabList: attrs.hidemobiletablist === 'true',
        buyRobuxUrl: attrs.buyrobuxurl,
        isTwoStepToggleEnabled: attrs.isTwoStepToggleEnabled,
        inApp: attrs.inApp === 'true',
        isPersonalSettingRefactorEnabled: attrs.isCountryLocaleRefactorEnabled === 'true',
        defaultThemeType: attrs.defaultThemeType,
        isMyAccountSectionHeaderHidden: attrs.isMyAccountSectionHeaderHidden === 'true'
      };
    }
  };
}

accountSettingsModule.directive('accountStateProperties', accountStateProperties);

export default accountStateProperties;
